/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */
import React from "react";
import PropTypes from "prop-types";
import "./style.less";
import axios from 'axios/dist/axios.min.js'
import utils from "../../utils/utils";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Exposure } from 'shihuo-lib/dist/shihuo-lib';

function hexColorToRgba(hexColor, opacity) {
  const alphaMaxVal = 1
  hexColor = hexColor.replace("#", "");

  //用于分割16进制色彩通道
  let reg = new RegExp("\\w{1,2}", "g");
  //分割颜色通道
  let rgbaArray255 = hexColor.match(reg);
  rgbaArray255 = rgbaArray255 && rgbaArray255.map((channel, index) => {
    //计算每个通道的10进制值
    let colorVal = parseInt(channel, 16);
    if (index === 3) {
      //这是alpha通道
      return Math.round(colorVal / (255 / alphaMaxVal) * 100) / 100
    }
    return colorVal;
  });
  return `rgb(${rgbaArray255.join(',')},${opacity})`;
}

class PipelineRecommendFeeds extends React.Component {
  constructor(props) {
    super(props);
    this.exp = new Exposure();
    this.state = {
      tabList: [],
      tabIndex: 0,
      navFixed: false,
      tabExpand: false,
      outScreen: false,
      tabBarHeight: 0
    };
    this.changed = false;
    this.isRequestTabOrder = false;
    this.canExposure = true;
    this.from = typeof window !== "undefined" ? (window.squareType == '主会场' ? 'sales_main_square' : window.squareName) : ''
    this.goods_type = 0
    // this.goods_type = typeof window !== "undefined" && (window.squareStageType == '预售' ? 1 : (window.squareStageType == '预热' ? 2 : (window.squareStageType == '全部商品' ? 0 : 3)))
    this.pageId = typeof window !== "undefined" ? (window.location.host === "zt-public.shihuo.cn"
      ? window.location.href.indexOf('zt-public.shihuo.cn/stage') > -1
        ? window.location.pathname.split("/")[3]
        : window.location.pathname.split("/")[2]
      : 0) : 0;
    this.isReset = false;
    this.changed = false;
  }

  componentDidMount() {
    this.getData()
    typeof window !== "undefined" && window.addEventListener("scroll", this.handleBodyScroll);
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.tabActive != nextProps.tabActive) {
      this.setState({
        navFixed: false
      })
    }
    return true
  }

  //获取商品数据
  getData = (tabIndex = 0, page = 1) => {
    const { list: curList = [] } = this.props.config
    const curItem = curList && curList[tabIndex] || {};
      const { mainPush = {} } = curItem;
      if (mainPush.configType === "商品id(维度)" || mainPush.configType === "配色id(维度)") {
        const pref = mainPush.configType === "商品id(维度)" ? 'g' : 'p'
        const { layout_goodsId, layout_styleId } = mainPush
        const itemList = ((pref == 'g' && layout_goodsId && layout_goodsId.id) || layout_styleId && layout_styleId.id).split(",");

        const idList = itemList && itemList.map((item) => {
          return isNaN(Number(item)) ? 0 : pref + item;
        });
        let tabList = curList
        tabList[tabIndex].isLoading = true;
        tabList[tabIndex].goodsList = [];
        tabList[tabIndex].page = 1;
        this.setState({
          tabList
        }, () => {
          axios({
            baseURL: 'https://sh-gateway.shihuo.cn',
            url: '/v4/services/sh-venueapi/common/goodsListByIds?access_token=znSnA7pxO35wtPBaur',
            method: "post",
            withCredentials: true,
            data: {
              goods_id: idList,
              goods_type: this.goods_type
            },
          }).then((res) => {
            if (res.data.status === 0) {
              const list = res.data.data.goods_list || [];
              res = res.data
              let goodsList = (tabList[tabIndex].goodsList || [])
              goodsList = goodsList.concat(list.map(goods => {
                return {
                  ...goods,
                  image: goods.pic,
                  title: goods.level == "g" ? goods.goodsName : (goods.goodsName + ' ' + goods.styleName),
                  original_price: goods.officialPrice,
                  url: goods.detailHref,
                  recommend: goods.tag || ''
                }
              }))
              tabList[tabIndex].isLoading = false
              tabList[tabIndex].page = 1
              tabList[tabIndex].noMore = false
              const adList = tabList[tabIndex].adList || []
              adList.forEach((ad) => {
                const { startTime, endTime, img, position } = ad
                const pos = +position.trim() - 1
                const now = new Date().getTime()
                if (startTime && endTime && img && pos >= 0 && now >= new Date(startTime).getTime() && now <= new Date(endTime).getTime()) {
                  ad.type = 'ad'
                  goodsList = goodsList.slice(0, pos).concat([ad]).concat(goodsList.slice(pos, goodsList.length))
                }
              })
              tabList[tabIndex].goodsList = goodsList
              tabList[tabIndex].noMore = true
              this.setState({
                tabList
              })

            }
          });
        })

      } else if (mainPush.configType === "二级类目id(维度)") {
        if (page === 1) {
          const itemList = curList.map((feedsItem, feedsIndex) => {
            const { layout_categoryId = {}, layout_goodsId = {}, layout_styleId = {} } = feedsItem.mainPush;
            const cateIds = layout_categoryId.id || layout_goodsId.id || layout_styleId.id;
            return cateIds
          })
          let cateList = [];
          itemList && itemList.map((cateItem, cateIndex) => {
            if (cateItem) {
              cateList.push({
                "key": cateIndex + "",
                "cate": cateItem
              });
            }
          });

          axios({
            baseURL:  'https://sh-gateway.shihuo.cn',
            url: '/v4/services/sh-venueapi/common/tabOrder?access_token=znSnA7pxO35wtPBaur',
            method: 'post',
            withCredentials: true,
            data: {
              cateList,
              scene: 'ACTIVITY_11_TAB_REC',
              from: window.location.href
            },
          }).then(res => {
            res = res.data
            const { list = [] } = this.props.config
            const copyList = JSON.parse(JSON.stringify(list))
            let tabList = list
            if (res.status == 0 && !this.isRequestTabOrder) {
              this.isRequestTabOrder = true;
              const { orderCateList = [] } = res.data || {}
              let mapIndex = 0
              orderCateList.forEach(key => {
                tabList.forEach((item, index) => {
                  if (key == index) {
                    for (let i = mapIndex; i < copyList.length; i++) {
                      const { layout_categoryId = {}, layout_goodsId = {}, layout_styleId = {} } = copyList[i].mainPush;
                      const cateIds = layout_categoryId.id || layout_goodsId.id || layout_styleId.id;
                      if (cateIds) {
                        tabList[i] = copyList[+key]
                        mapIndex = i + 1
                        break
                      }
                    }
                  }            
                })
              })
      
            }
            tabList.forEach((tab, tabIndex) => {
              // 推荐置顶
              if (tab.tabName == "推荐") {
                tabList.splice(tabIndex, 1);
                tabList.unshift(tab);
              }
              tab.goodsList = []
              tab.page = 1
            })
            tabList[tabIndex].isLoading = false;
            this.setState({
              tabList
            }, () => {
              const { tabBarHeight } = this.state;
              setTimeout(() => {
                this.setState({
                  outScreen: typeof window !== "undefined" && window.squareType == '主会场' ? true : document.querySelector('.single-line') && document.querySelector('.single-line').scrollWidth > document.querySelector('.recommend-feeds-tab-list').clientWidth,
                  tabBarHeight: tabBarHeight > 0 ? tabBarHeight : (typeof window !== "undefined" && window.document.querySelector('.recommend-feeds-tab').clientHeight)
                })
              }, 0);
              this.getGoodsList(tabIndex, 1)
            })
          })
        } else {
          this.getGoodsList(tabIndex, page)
        }
      }

  }

  getGoodsList = (tabIndex, page) => {
    const { tabList } = this.state
    const tab = tabList[tabIndex] || {}

    if (tab.isLoading) {
      return
    }
    if (tab.noMore) {
      return
    }
    tab.isLoading = true
    this.setState({
      tabList
    })
    const page_size = window.squareType == '主会场' ? 21 : 20
    if (page == 1) {
      tab.from = 'recommend'
    }
    const { mainPush = {} } = tab;
    const itemList = (mainPush.layout_categoryId && mainPush.layout_categoryId.id || '').split(",") || [];
    const idList = itemList && itemList.map((item) => {
      return isNaN(Number(item)) ? 0 : item;
    });

    const squareStageType = window.squareStageType;
    let goods_type = 0;
    switch (squareStageType) {
      case "预售":
        goods_type = 1
        break;
      case "预热":
        goods_type = 2
        break;
      case "正式":
        goods_type = 3
        break;
      case "全部商品":
        goods_type = 0
        break;
      default:
        break;
    }

    axios({
      baseURL:  'https://sh-gateway.shihuo.cn',
      url: '/v4/services/sh-venueapi/common/goodsListByCate?access_token=znSnA7pxO35wtPBaur',
      method: 'post',
      withCredentials: true,
      data: {
        cate: idList,
        page_size,
        page_on: page,
        goods_type: goods_type,
        from: window.location.href,
        scene: 'ACTIVITY_11_GOODSLIST_REC',
        goods_from: tab.from == 'search' ? 1 : 0
      },
    }).then(res => {
      tab.isLoading = false
      this.setState({
        tabList
      })
      res = res.data
      if (res.status == 0) {
        const list = res.data.goods_list || []
        let goodsList = page == 1 ? [] : (tab.goodsList || [])
        goodsList = goodsList.concat(list.map(goods => {
          return {
            ...goods,
            image: goods.pic,
            title: goods.level == "g" ? goods.goodsName : (goods.goodsName + ' ' + goods.styleName),
            original_price: goods.officialPrice,
            url: goods.detailHref,
            recommend: goods.tag || ''
          }
        }))
        tab.page = page
        tab.noMore = list.length < 20

        this.isReset = false;
        if (page == 1) {
          const adList = tab.adList || []
          adList.forEach((ad) => {
            const { startTime, endTime, img, position } = ad
            const pos = +position.trim() - 1
            const now = new Date().getTime()
            if (startTime && endTime && img && pos >= 0 && now >= new Date(startTime).getTime() && now <= new Date(endTime).getTime()) {
              ad.type = 'ad'
              goodsList = goodsList.slice(0, pos).concat([ad]).concat(goodsList.slice(pos, goodsList.length))
            }
          })
        }
        if (tab.from != res.data.from && res.data.from == 'search') {
          page = 1
          tab.page = 1
          this.isReset = true
        }
        tab.from = res.data.from
        tab.goodsList = goodsList

        this.setState({
          tabList
        })
      } else {
        tab.noMore = true;
        this.setState({
          tabList
        })
      }
    })
  }

  handleBodyScroll = () => {

    let targetTabContainer;
    if (this.props.tabActive) {
      targetTabContainer = window.document.querySelectorAll('.tab-container')[this.props.tabActive];
      if (!targetTabContainer || !targetTabContainer.querySelector('.recommend-feeds-tab')) {
        return
      }
    }

    if (!window.document.querySelector('.recommend-feeds-tab')) {
      return
    }
    
    let navOffsetTop, navFixed;
    const { tabBarHeight } = this.state

    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
    if (this.props.tabActive) {
      navOffsetTop = targetTabContainer && targetTabContainer.querySelector('.recommend-feeds-tab') && targetTabContainer.querySelector('.recommend-feeds-tab').offsetTop - this.props.navigationBarHeight;
    } else {
      navOffsetTop = window.document.querySelector('.recommend-feeds-tab').offsetTop - this.props.navigationBarHeight;
    }
    const isMain = window.squareType == '主会场'
    // const navMarginTop = Number(this.props.config.baseConfig.moduleMarginTop); // 导航模块上边距
    // let navMarginTop = isMain ? (tabBarHeight / 36 - 1) * 36 : 0; // 导航模块上边距
    let navMarginTop = isMain ? 0 : 0; 
    if (utils.isAndroid()) {
      // navMarginTop = navMarginTop - 44
    }
    if (this.props.tabActive) {
      navFixed = targetTabContainer.querySelector('.recommend-feeds-wrapper') && scrollHeight - navOffsetTop > navMarginTop && scrollHeight - navOffsetTop - targetTabContainer.querySelector('.recommend-feeds-wrapper').clientHeight < navMarginTop - tabBarHeight;
    } else {
      navFixed = scrollHeight - navOffsetTop > navMarginTop && scrollHeight - navOffsetTop - window.document.querySelector('.recommend-feeds-wrapper').clientHeight < navMarginTop - tabBarHeight
    }
    if (navFixed != this.state.navFixed) {
      if (navFixed) {
        this.setState({
          navFixed: true,
          tabExpand: false
        }, () => {
          let tabItemEls;
          if (this.props.tabActive) {
            tabItemEls = targetTabContainer.querySelectorAll('.recommend-feeds-tab-item')
          } else {
            tabItemEls = window.document.querySelectorAll('.recommend-feeds-tab-item')
          }
          const index = this.state.tabIndex
          if (tabItemEls && tabItemEls[index]) {
            tabItemEls[index].scrollIntoView()
          }
        });
      } else {
        this.setState({
          navFixed: false,
          tabExpand: false
        });
      }
    }

    const tabIndex = this.state.tabIndex
    const sHeight = document.documentElement.scrollHeight || document.body.scrollHeight
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    const height = document.documentElement.clientHeight || document.body.clientHeight
    if (scrollTop + height > sHeight - 280 && !this.changed) {
      this.getGoodsList(tabIndex, this.state.tabList[tabIndex] ? this.state.tabList[tabIndex].page + 1 : 1)
    }
  }

  handleTabClick = (index) => {
    const { tabBarHeight } = this.state
    const { tabList } = this.state
    const newProps = JSON.parse(JSON.stringify(this.props));
    Object.assign(newProps, {
      tabChName: tabList[index] && tabList[index].tabName
    });
    utils.uploadTrack(newProps, {
      sort: index
    },{bizExtra: { model_block: 'tab' }});
    if (typeof window == "undefined") {
      return
    }
    const targetTabContainer = window.document.querySelectorAll('.tab-container')[newProps.tabActive]
    let scrollTop;
    if (this.props.tabActive) {
      scrollTop = targetTabContainer && targetTabContainer.querySelector('.recommend-feeds-wrapper') && targetTabContainer.querySelector('.recommend-feeds-wrapper').offsetTop - this.props.navigationBarHeight + (window.squareType == '主会场' ? ((tabBarHeight / 36 - 1) * 36 + 5) : 10) 
    } else {
      scrollTop = window.document.querySelector('.recommend-feeds-wrapper').offsetTop - this.props.navigationBarHeight + (window.squareType == '主会场' ? ((tabBarHeight / 36 - 1) * 36 + 5) : 10)
    }
    if (utils.isAndroid()) {
      // scrollTop = scrollTop - 38
    }
    window.scrollTo(0, scrollTop);

    const changed = index != this.state.tabIndex
    this.changed = changed;
    if (changed) {
      tabList[index].goodsList = []
      tabList[index].noMore = false
      this.getData(index, 1)

      setTimeout(() => {
        this.changed = false;
      }, 1000);
    }
    this.setState({
      tabIndex: index,
      navFixed: true,
      tabExpand: false,
    }, () => {
      let tabItemEls;
      if (this.props.tabActive) {
        tabItemEls = targetTabContainer.querySelectorAll('.recommend-feeds-tab-item');
        if (tabItemEls && tabItemEls[index]) {
          if (targetTabContainer.querySelector('.single-line')) {
            targetTabContainer.querySelector('.single-line').scrollLeft = tabItemEls[index].offsetLeft - window.innerWidth / 2 + tabItemEls[index].clientWidth / 2
          }
        }
      } else {
        tabItemEls = window.document.querySelectorAll('.recommend-feeds-tab-item');
        if (tabItemEls && tabItemEls[index]) {
          if (window.document.querySelector('.single-line')) {
            window.document.querySelector('.single-line').scrollLeft = tabItemEls[index].offsetLeft - window.innerWidth / 2 + tabItemEls[index].clientWidth / 2
          }
        }
  
      }
    })
  }

  expandClick = () => {
    const tabExpand = !this.state.tabExpand
    const index = this.state.tabIndex
    this.setState({
      tabExpand
    }, () => {
      if (!tabExpand) {
        const tabItemEls = window.document.querySelectorAll('.recommend-feeds-tab-item')
        if (tabItemEls && tabItemEls[index]) {
          if (window.document.querySelector('.single-line')) {
            window.document.querySelector('.single-line').scrollLeft = tabItemEls[index].offsetLeft - window.innerWidth / 2 + tabItemEls[index].clientWidth / 2
          }
        }
      }
    })
  }

  render() {
    const customAttributes = {
      "data-component-id": this.props["data-component-id"],
      "data-component-name": this.props["data-component-name"],
    };

    const { baseConfig } = this.props.config;
    const { tabList, tabIndex, navFixed, tabExpand, outScreen, tabBarHeight } = this.state

    if (tabList.length == 0) {
      return null
    }

    const tab = tabList[tabIndex]
    if (typeof window == "undefined") {
      return
    }
    const isMain = window.squareType == '主会场'
    let windowColor = ''
    if(typeof window != 'undefined' && window.backgroundColor){
      windowColor = window.backgroundColor
    }else if(document.querySelector('body').style.backgroundColor){
      windowColor = document.querySelector('body').style.backgroundColor
    }
    return (
      <div
        className="recommend-feeds-wrapper"
        {...this.props['customAttributes']}
        style={{
          marginTop: `${baseConfig.moduleMarginTop}px`,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`,
        }}
      >
        {tabExpand && <div className="goods-mask" onClick={this.expandClick}></div>}
        <div
          className={"recommend-feeds-tab " + (isMain ? '' : 'fen')}
        >
          <div
            className={`recommend-feeds-tab-list ${(isMain && navFixed) || (!isMain && outScreen) ? 'single' : ''}`}
            style={{
              position: navFixed ? 'fixed' : 'relative',
              top: navFixed ? this.props.navigationBarHeight : 0,
              background: this.props.tabContainerBgColor || windowColor
            }}
          >
            <div
              className={`cont single-line ${tabExpand ? 'expand' : ''}`}
              style={{
                background: this.props.tabContainerBgColor || windowColor
              }}
            >
              {
                tabList && tabList.map((item, index) => {
                  return (
                    <div onClick={this.handleTabClick.bind(this, index)} className={`recommend-feeds-tab-item tab-item-new ${tabIndex == index ? 'active' : ''}`} key={index}>{item.tabName}</div>
                  )
                })
              }
            </div>
          </div>
        </div>
        {
          navFixed && isMain &&
          <div style={{ height: tabBarHeight }}></div>
        }
        <div className="goods-block-list" style={{ minHeight: '100vh', marginTop: 0 }}>
          {
            <div className="recommend-item" key={tabIndex}>
              <div className="goods-list" style={{ minHeight: '30vh' }}>
                {
                  tab.goodsList && tab.goodsList.map((item, index) => {
                    if (item.type == 'ad') {
                      if (this.canExposure) {
                        return (
                          <div
                          // className={isMain ? `goods-item` : 'goods-item-2' + ' ad'} 
                          className={'goods-item' + ' ad'} 
                          key={`${index}`}
                            data-dot={JSON.stringify({
                              id: `lego-sales:tab_${tabIndex}-list:${index}`,
                              name: '',
                              href: '',
                              biz: JSON.stringify({
                                ptiId: `lego-sales:tab_${tabIndex}-list:${index}`,
                                page_id: this.pageId,
                                pageId: this.pageId,
                                from_sort: index,
                                tabChName: tab.tabName,
                                goods_id: item.goodsId || item.id || '',
                                style_id: item.styleId || ''
                              }),
                              exposekey: `.za..${this.from}.feed_list....${index}......${tab.tabName}@${new Date().valueOf()}`,
                              pti_refer: {
                                pageId: '',
                                root: {
                                  id: '',
                                  pageId: '',
                                  name: '',
                                  biz: '',
                                },
                                parent: {
                                  id: '',
                                  pageId: '',
                                  name: '',
                                  biz: '',
                                },
                              },
                            })}
                            ref={ele => {
                              if (ele) {
                                this.exp.add({ el: ele });
                              }
                            }}
                            onClick={() => {
                              const options = {
                                sort: index,
                                tabChName: tab.tabName,
                              }
                              utils.jumpToUrl(this.props.routeParams, item.url, item.url, options, -1, {...this.props,...options}, false, { bizExtra: { model_block: 'list' },tabChName: tab.tabName,goods_id: item.goodsId || item.id || '',style_id: item.styleId || '' });
                            }}
                          >
                            <LazyLoadImage
                              width="100%"
                              threshold={500}
                              height="100%"
                              src={utils.formatImgUrl(item.img, this.props.webpSupport)}
                              effect="opacity"
                            />
                          </div>
                        )
                      } else {
                        <div
                        // className={isMain ? `goods-item` : 'goods-item-2' + ' ad'} 
                        className={`goods-item` + ' ad'} 
                        key={`${index}`}
                          onClick={() => {
                            const options = {
                              sort: index,
                              tabChName: tab.tabName,
                            }
                            utils.jumpToUrl(this.props.routeParams, item.url, item.url, options, -1, {...this.props,...options}, false, { bizExtra: { model_block: 'list' },tabChName: tab.tabName,goods_id: item.goodsId || item.id || '',style_id: item.styleId || '' });
                          }}
                        >
                          <LazyLoadImage
                            width="100%"
                            threshold={500}
                            height="100%"
                            src={utils.formatImgUrl(item.img, this.props.webpSupport)}
                            effect="opacity"
                          />
                        </div>
                      }
                    } else {
                      if (this.canExposure) {
                        return (
                          <div
                          // className={isMain ? `goods-item` : 'goods-item-2'} 
                          className={`goods-item`} 
                          key={`${index}`}
                            data-dot={JSON.stringify({
                              id: `lego-sales:tab_${tabIndex}-list:${index}`,
                              name: '',
                              href: '',
                              biz: JSON.stringify({
                                ptiId: `lego-sales:tab_${tabIndex}-list:${index}`,
                                page_id: this.pageId,
                                pageId: this.pageId,
                                from_sort: index,
                                tabChName: tab.tabName,
                                goods_id: item.goodsId || item.id || '',
                                style_id: item.styleId || ''
                              }),
                              exposekey: `.zf.goodsDetail.${this.from}.favor_recommend..${item.goodsId || item.id || ''}.${item.styleId || ''}.${index}...${tab.tabName}@${new Date().valueOf()}`,
                              pti_refer: {
                                pageId: '',
                                root: {
                                  id: '',
                                  pageId: '',
                                  name: '',
                                  biz: '',
                                },
                                parent: {
                                  id: '',
                                  pageId: '',
                                  name: '',
                                  biz: '',
                                },
                              },
                            })}
                            ref={ele => {
                              if (ele) {
                                this.exp.add({ el: ele });
                              }
                            }}
                            onClick={() => {
                              const options = {
                                sort: index,
                                tabChName: tab.tabName,
                              }
                              utils.jumpToUrl(this.props.routeParams, item.url, item.url, options, -1, {...this.props,...options}, false, { bizExtra: { model_block: 'list' },tabChName: tab.tabName,goods_id: item.goodsId || item.id || '',style_id: item.styleId || '' });
                            }}
                          >
                            <div className="goods-img">
                              <LazyLoadImage
                                width="100%"
                                threshold={500}
                                height="100%"
                                src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                                effect="opacity"
                              />
                              {item.tag2 && <div className="top-tag"><div className={`tag-cont a${['识货补贴', '百亿补贴', '京东秒杀'].indexOf(item.tag2)}`}>{item.tag2}</div></div>}
                            </div>
                            <div className="name" style={{ WebkitBoxOrient: "vertical" }}>{item.title}</div>
                            <div className="price">
                              <span className="cur-price"><span>¥</span>{item.price || '--'}</span>
                              {item.original_price > 0 && <span className="origin-price">¥{item.original_price}</span>}
                            </div>
                            {
                              item.recommend &&
                              <div className="tag-block">
                                {/* {!isMain && item.tag2 && <div className={`tag ${['识货补贴','百亿补贴','京东秒杀'].indexOf(item.tag2) > -1 ? 'deep' : ''}`}>{item.tag2}</div>} */}
                                <div className="tag">{item.recommend}</div>
                              </div>
                            }
                            {
                              window.squareType == '分会场' && item.hits > 0 &&
                              <div className="hot">
                                热度{item.hits}
                              </div>
                            }
                          </div>
                        )
                      } else {
                        return (
                          <div
                          // className={isMain ? `goods-item` : 'goods-item-2'} 
                          className={`goods-item`} 
                          key={`${index}`}
                            onClick={() => {
                              const options = {
                                sort: index,
                                tabChName: tab.tabName,
                              }
                              utils.jumpToUrl(this.props.routeParams, item.url, item.url, options, -1, {...this.props,...options}, false, { bizExtra: { model_block: 'list' },tabChName: tab.tabName,goods_id: item.goodsId || item.id || '',style_id: item.styleId || '' });
                            }}
                          >
                            <div className="goods-img">
                              <LazyLoadImage
                                width="100%"
                                threshold={500}
                                height="100%"
                                src={utils.formatImgUrl(item.image, this.props.webpSupport)}
                                effect="opacity"
                              />
                              {item.tag2 && <div className="top-tag"><div className={`tag-cont a${['识货补贴', '百亿补贴', '京东秒杀'].indexOf(item.tag2)}`}>{item.tag2}</div></div>}
                            </div>
                            <div className="name" style={{ WebkitBoxOrient: "vertical" }}>{item.title}</div>
                            <div className="price">
                              <span className="cur-price"><span>¥</span>{item.price || '--'}</span>
                              {item.original_price > 0 && <span className="origin-price">¥{item.original_price}</span>}
                            </div>
                            {
                              item.recommend &&
                              <div className="tag-block">
                                {/* {!isMain && item.tag2 && <div className={`tag ${['识货补贴','百亿补贴','京东秒杀'].indexOf(item.tag2) > -1 ? 'deep' : ''}`}>{item.tag2}</div>} */}
                                <div className="tag">{item.recommend}</div>
                              </div>
                            }
                            {
                              window.squareType == '分会场' && item.hits > 0 &&
                              <div className="hot">
                                热度{item.hits}
                              </div>
                            }
                          </div>
                        )
                      }
                    }
                  })
                }
              </div>
              <div className={`bottom-status ${tab.isLoading || tab.noMore ? 'no-more' : ''}`} onClick={this.getGoodsList.bind(this, tabIndex, tab.page + 1)}>
                {tab.isLoading ? '加载中..' : tab.noMore ? '- 没有更多了 -' : '加载中..'}
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

PipelineRecommendFeeds.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineRecommendFeeds };
export default PipelineRecommendFeeds;



// WEBPACK FOOTER //
// ./components/pipeline-recommend-feeds/index.js